/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2024 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../../core/IceEntity';

export class previouscertification extends IceEntity {
  previous_certification_key: string = "";
  certification_identifier: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;

  gettablename(): string {
    return "PREVIOUS_CERTIFICATION";
  }
}
